// millseconds转换时，分，秒
export const mill2hms = mills => {
  const htime = 60 * 60 * 1000
  const mtime = 60 * 1000
  const stime = 1000
  const h = Math.floor(mills / htime)
  mills = mills - h * htime
  const m = Math.floor(mills / mtime)
  mills = mills - m * mtime

  const s = Math.floor(mills / stime)
  return {
    hour: h,
    minute: m,
    sec: s
  }
}

/*
  countDownTime 倒计时时长
  onUpdate  倒计时更新的回调
*/
export class CountDown {
  constructor(data) {
    if (data) {
      this.start(data)
    }
  }

  init({ countDownTime, onUpdate }) {
    this.timer = null
    this.countDownTime = countDownTime || 0
    this.startClientTime = new Date().getTime()
    this.onUpdate = onUpdate || function () {}
  }

  stop() {
    clearTimeout(this.timer)
  }

  start(data) {
    this.stop()
    if (data) {
      this.init(data)
    }
    this._start()
  }

  _start() {
    const EMPTY = {
      h: '00',
      m: '00',
      s: '00',
      countDownTime: 0
    }
    if (!this.countDownTime || this.countDownTime <= 0) {
      this.onUpdate(EMPTY)
      return
    }

    // 时间加0补齐
    var t2str = function (value) {
      const v = +value
      return v > 9 ? value : `0${value}`
    }

    var func = () => {
      const diff = new Date().getTime() - this.startClientTime
      const currDiff = this.countDownTime - diff
      // 倒计时结束，刷新商品状态
      if (currDiff < 0) {
        this.onUpdate(EMPTY)
        return
      }

      const countDownTime = Math.max(currDiff, 0)
      const hms = mill2hms(countDownTime)
      this.onUpdate({
        h: t2str(hms.hour),
        m: t2str(hms.minute),
        s: t2str(hms.sec),
        countDownTime: countDownTime
      })

      this.timer = setTimeout(func, 300)
    }
    func()
  }
}
